import { t } from 'i18next';
import React from 'react';
import ReactPaginate from 'react-paginate';
import { Menu, Table } from 'semantic-ui-react';
import LoadingAnimation from '../../components/LoadingAnimation';

const LogsTable = ({ isAdmin, loginLogs, pageCount, changePage, pageOptions, next, isload }) => {
  let num = 1;

  return (
    <div
      className={`${isAdmin && 'pt-40 pb-96  '} sm:pb-5 overflow-x-auto overflow-y-hidden `}
      style={isAdmin ? { scrollbarWidth: 'thin', margin: '20px' } : { scrollbarWidth: 'thin' }}
    >
      {isload ? (
        <LoadingAnimation imageStyling={''} styling={'flex items-center py-5 align-middle justify-center space-x-2'} />
      ) : (
        <Table className="table text-sm text-left rtl:text-right ">
          <Table.Header className="text-xs  text-white bg-customgreen uppercase ">
            <Table.Row className="">
              {['sNo', 'TransType', 'CountryName', 'Date', 'Time'].map((column, index) => (
                <Table.Cell key={index} scope="col" className="px-6 py-3 font-semibold text-white whitespace-nowrap ">
                  {t(`${column}`)}
                </Table.Cell>
              ))}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {loginLogs?.map((item, index) => {
              const sno = (next - 1) * pageOptions.pageSize + index + 1;
              return (
                <Table.Row className={`border-b   ${index % 2 === 0 ? '' : ''}`}>
                  <Table.Cell className="px-6 py-4 border-x font-medium">{sno}</Table.Cell>
                  <Table.Cell className="px-6 py-4 border-x ">{item?.transType}</Table.Cell>
                  {/* <Table.Cell className="px-6 py-4 border-x ">date</Table.Cell> */}
                  <Table.Cell className="px-6 py-4 border-x ">{t(item?.countryName)}</Table.Cell>
                  <Table.Cell className="px-6 py-4 border-x ">{item?.date}</Table.Cell>
                  <Table.Cell className="px-6 py-4 border-x ">{item?.timeNow}</Table.Cell>
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      )}
      <div className={`flex flex-row px-12 ${isAdmin && 'pb-48'}  my-4 justify-between`}>
        <Menu floated="right" pagination>
          <Menu.Item>
            <ReactPaginate
              previousLabel={t('Previous')}
              nextLabel={t('Next')}
              pageCount={pageCount}
              onPageChange={changePage}
              containerClassName={'paginationButtons'}
              previousLinkClassName={'previousButton'}
              nextLinkClassName={'nextButton'}
              disabledClassName={'paginationDisabled'}
              activeClassName={'paginationActive'}
            />
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );
};

export default LogsTable;
